






























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    request: {
        createdBy: {
            displayName: string;
        }
    };
    topic: {
        title: string;
    };
    subtopic: {
        title: string;
    };
}

@Component({ components: { SimpleText } })
export default class Topic extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.topic.title",
            "insertion.subtopic.title",
            "insertion.request.createdBy.displayName",
            "insertion.request.code",
        ];
    }
}
